__turbopack_context__.v({
  "productItem": "CheckoutInvalidItemsList-module-scss-module__kF07jW__productItem",
  "productList": "CheckoutInvalidItemsList-module-scss-module__kF07jW__productList",
  "unavailableProductsList": "CheckoutInvalidItemsList-module-scss-module__kF07jW__unavailableProductsList",
  "unavailableProductsTitle": "CheckoutInvalidItemsList-module-scss-module__kF07jW__unavailableProductsTitle",
});
